import { Skeleton } from '@ria-client/tw-shadcn/components/skeleton';
import { TableCell, TableRow } from '@ria-client/tw-shadcn/components/table';

export interface SkeletonRowProps {
  driversLength?: number;
}

export function SkeletonRow({ driversLength = 2 }: SkeletonRowProps) {
  return (
    <TableRow className="[&:last-of-type_td]:border-b-0" data-testid="skeleton-row">
      <TableCell className="border-r-[var(--content-neutral-lighter-2)] border-b-[var(--content-neutral-lighter-2)] bg-muted p-0">
        <div className="flex h-full flex-col items-center gap-2 px-2 py-3">
          <Skeleton className="h-11 w-[122px]" />
          <Skeleton className="h-11 w-[120px]" />
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-[70px] w-full" />
          <Skeleton className="h-3.5 w-[100px]" />
        </div>
      </TableCell>
      <TableCell className="border-b-[var(--content-neutral-lighter-2)] border-l-0 align-top">
        <div className="flex h-full flex-col gap-3">
          {Array.from({ length: driversLength }).map((_, index) => (
            <Skeleton className="h-[75px] w-full" key={index} />
          ))}
        </div>
      </TableCell>
    </TableRow>
  );
}
